import { render, staticRenderFns } from "./dialogPickTest.vue?vue&type=template&id=bdc69386&scoped=true"
import script from "./dialogPickTest.vue?vue&type=script&lang=js"
export * from "./dialogPickTest.vue?vue&type=script&lang=js"
import style0 from "./dialogPickTest.vue?vue&type=style&index=0&id=bdc69386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc69386",
  null
  
)

export default component.exports